import { onlyWhenSupport } from '@tectonics/prs/validation';
import type { UserInputValidationError, UserInputValidatorArgs } from '@tectonics/prs/validation';

import { validateCustomerName } from './customer-name';
import { validateCustomerEmail } from './customer-email';
import { getCurrentFeatures } from '@tectonics/prs/payment-spec';
import {
  getCurrentPaymentMethodOptionalFields,
  hasOptionalField,
} from '@tectonics/prs/incoming-payment/get-payment-type-optional-fields';
import { validateCustomerBirthdate } from './customer-birthdate';

export function validator({
  spec,
  prsSupport,
  userInputName,
  userInputValue,
  userInputValues,
  incomingPayment,
}: UserInputValidatorArgs): UserInputValidationError | null | undefined {
  const value = typeof userInputValue === 'string'
    ? userInputValue
    : '';
  const currentFeatures = getCurrentFeatures(spec, userInputValues['selectedPaymentMethod']);
  const onlyWhen = onlyWhenSupport(currentFeatures, prsSupport);
  const optionalFields = incomingPayment.status === 'OP' ? getCurrentPaymentMethodOptionalFields(incomingPayment, userInputValues, spec) : [];
  const isCriptocurrencyPaymentMethod = userInputValues['selectedPaymentMethod'] === 'cryptocurrency';

  switch (userInputName) {
    case 'customerName':
      if (!hasOptionalField(optionalFields, 'name')) {
        return onlyWhen('field_customer_name') && validateCustomerName(value);
      }
      return null;

    case 'customerEmail':
      if (hasOptionalField(optionalFields, 'email')) {
        return null;
      }
      return onlyWhen('field_customer_email') && validateCustomerEmail(value);

    case 'customerBirthdate':
      return isCriptocurrencyPaymentMethod ? validateCustomerBirthdate(value) : null;

    default:
      return undefined;
  }
}
